import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const ScrollToTop = () => {
    const {pathname} = useLocation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        window.scrollTo({top: 0});
    }, [pathname]);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 1200);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleClick = () => {
        window.scrollTo({top: 0, behavior: "smooth"});
    };

    return (
        <button onClick={handleClick} className={`scroll-to-top ${visible ? "visible" : ""}`}>
            <KeyboardArrowUpIcon fontSize="large" />
        </button>
    );
};

export default ScrollToTop;
